var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 19,
    viewBox: "0 0 18 19",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z",
    transform: "translate(0 .5)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 .5c-4.95 0-9 3.63-9 8.112 0 4.48 4.05 8.111 9 8.111.9 0 1.875-.154 2.775-.386l3.15 2.009c.075.077.15.077.3.077.075 0 .225 0 .3-.077l.225-.232c.075-.078.075-.155.075-.31v-3.94c.675-.695 1.275-1.544 1.65-2.471s.6-1.932.6-2.936c-.075-4.326-4.125-7.957-9.075-7.957zm.975 13.597c-.225.231-.45.309-.75.309-.225 0-.375-.078-.6-.155-.15-.154-.3-.309-.375-.463-.075-.232-.075-.387-.075-.619.075-.231.15-.386.3-.54.15-.155.3-.232.525-.31.225-.077.45 0 .6.078a.775.775 0 0 1 .45.386c.15.155.15.386.15.618.075.232-.075.464-.225.696zm2.25-6.876c-.225.309-.6.773-1.2 1.39-.45.387-.675.773-.825 1.005-.15.309-.15.154-.15.695 0 0 0 .773-.825.773-.75 0-.75-.773-.75-.773 0-.695.075-.695.225-1.159.15-.463.525-.927 1.05-1.467l.525-.541c.15-.155.3-.31.375-.464.15-.231.225-.54.225-.85 0-.386-.15-.772-.375-1.081-.225-.31-.6-.464-1.2-.464-.675 0-1.125.232-1.425.773-.15.309-.225.463-.225 1.004 0 0 0 .773-.75.773-.9.232-.825-.696-.825-.696 0-1.081.3-1.545.9-2.24a3.287 3.287 0 0 1 2.4-1.004c.975 0 1.725.309 2.25.85.6.54.9 1.236.9 2.163 0 .54-.075 1.004-.3 1.313z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.f8e1cf3103f8a1b48c62afe78d6d5e65.svg";
export { ForwardRef as ReactComponent };